import * as tslib_1 from "tslib";
import { Sprite } from "../../display/Sprite";
var Quad = (function (_super) {
    tslib_1.__extends(Quad, _super);
    function Quad(param1, param2, param3) {
        if (param1 === void 0) { param1 = 0; }
        if (param2 === void 0) { param2 = 0; }
        if (param3 === void 0) { param3 = 0; }
        return _super.call(this) || this;
    }
    return Quad;
}(Sprite));
export { Quad };
